import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'

import Layout from './sandwich-shop.views'

const SandwichShopHero = () => {
  const { template } = useTemplateContext()

  return (
    <Layout className='select-none pointer-events-none'>
      <Layout.Hero backgroundImage={template.sections.hero.backgroundImage} afterBackgroundColor="#00000030" textColor="textSecondary">
        <Layout.Header backgroundColor="complementary" textColor="textPrimary">
          <CommonComponents.Wrapper>
            <Layout.Logo>
              {template.logo.src ? (
                <Layout.LogoImage src={template.logo.src} />
              ) : (
                <Layout.LogoText fontFamily={template.logo.fontFamily}>
                  {template.logo.text}
                </Layout.LogoText>
              )}
            </Layout.Logo>
            <Layout.Navigation hasShoppingCart={template.sections.navigation.hasShoppingCart}>
              {template.sections.navigation.links?.map((link, index) => <Layout.Link key={index}>{link}</Layout.Link>)}
              <Layout.Button type="primary" textColor="textSecondary">{template.sections.navigation.ctaText}</Layout.Button>
            </Layout.Navigation>
          </CommonComponents.Wrapper>
        </Layout.Header>
        <Layout.HeroContainer>
          <Layout.TitleContainer>
            <Layout.Title>{template.sections.hero.title}</Layout.Title>
          </Layout.TitleContainer>
        </Layout.HeroContainer>
      </Layout.Hero>
    </Layout>
  )
}

export default SandwichShopHero
